module.exports = __webpack_public_path__ + "img/ic_life_mart.2f28715b.png";